import React from 'react';
import './AwsCertificationsAnnouncement.css';
import { useNavigate } from 'react-router-dom';

const AwsCertificationsAnnouncement: React.FC = () => {
    const navigate = useNavigate();
    const handleReturn = () => {
        navigate('/');
    };

    return (
        <div className="aws-cert-announcement-page">
            <button className="return-button" onClick={handleReturn}>
              ←
            </button>
            <div className="announcement-header">
                <h1>「2026 Japan All AWS Certifications Engineers」選出のお知らせ</h1>
            </div>
            <div className="announcement-content">
                <p>2026年6月25日、当社社員6名がアマゾン ウェブ サービス ジャパン合同会社（AWS）の表彰プログラム「2026 Japan All AWS Certifications Engineers」に選出されました。</p>
                <p>日頃よりご支援いただいている皆様に心より感謝申し上げますとともに、今後もAWSに関する高い専門性を活かし、より一層品質の高いサービスを提供してまいります。</p>
            </div>
            <div className="announcement-section">
                <h2>Japan All AWS Certifications Engineers とは</h2>
                <p>「Japan All AWS Certifications Engineers」とは、AWS Partner Network（APN）に参加している企業に所属し、対象となるAWS認定資格を全て保持しているエンジニアを対象とした、AWSによる表彰プログラムです。</p>
                <p>2026年度は全国で2,329名のエンジニアが受賞しており、当社からは6名が選出されました。</p>
            </div>
            <div className="announcement-section">
                <h2>詳細</h2>
                <p>
                    受賞者の詳細につきましては、AWS公式ブログをご覧ください。
                </p>
                <p>
                    <a
                        href="https://aws.amazon.com/jp/blogs/psa/2026-japan-all-aws-certifications-engineers/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="aws-blog-link"
                    >
                        2026 Japan All AWS Certifications Engineers の発表（AWS公式ブログ）
                    </a>
                </p>
            </div>
            <div className="announcement-section">
                <h2>今後の取り組み</h2>
                <p>当社は、AWSセレクトティアサービスパートナーとして、引き続き社員の技術力向上に努め、クラウド技術を活用した高品質なソリューションの提供を通じて、お客様のビジネスの発展に貢献してまいります。</p>
                <p>今後ともご愛顧賜りますよう、よろしくお願い申し上げます。</p>
            </div>
        </div>
    );
};

export default AwsCertificationsAnnouncement;
